<template>
  <v-card class="elevation-0 pa-4">
    <v-row dense align="center">
      <v-col cols="12" md="auto">
        <span class="font-weight-medium text-body-2">Período</span>
      </v-col>

      <v-col cols="12" md="2">
        <v-menu
          v-model="menuDataInicio"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="dataInicioFormatada"
              dense
              outlined
              readonly
              hide-details
              v-bind="attrs"
              v-on="on"
              prepend-inner-icon="mdi-calendar"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="dataInicio"
            type="month"
            @input="onDataInicioChange"
            :max="dataFim"
            no-title
            scrollable
            locale="pt-br"
          ></v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="12" md="6">
        <div class="px-4">
          <v-range-slider
            v-model="rangeSlider"
            :min="0"
            :max="Math.max(0, mesesDisponiveis.length - 1)"
            hide-details
            class="align-center"
            @change="atualizarDatasDoSlider"
          >
            <template v-slot:prepend>
              <div class="slider-date-label">
                {{
                  mesesDisponiveis[rangeSlider[0]]
                    ? formatarMesAno(mesesDisponiveis[rangeSlider[0]])
                    : ""
                }}
              </div>
            </template>
            <template v-slot:append>
              <div class="slider-date-label">
                {{
                  mesesDisponiveis[rangeSlider[1]]
                    ? formatarMesAno(mesesDisponiveis[rangeSlider[1]])
                    : ""
                }}
              </div>
            </template>
          </v-range-slider>
        </div>
      </v-col>

      <v-col cols="12" md="2">
        <v-menu
          v-model="menuDataFim"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="dataFimFormatada"
              dense
              outlined
              readonly
              hide-details
              v-bind="attrs"
              v-on="on"
              prepend-inner-icon="mdi-calendar"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="dataFim"
            type="month"
            @input="onDataFimChange"
            :min="dataInicio"
            no-title
            scrollable
            locale="pt-br"
          ></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import dayjs from "dayjs";
import { periodoPadrao } from "@/utils/periodoDashboardLno";

export default {
  name: "FiltroMesRange",

  props: {
    value: {
      type: Object,
      default: () => ({
        dataInicio: null,
        dataFim: null,
      }),
    },
    dataMinima: {
      type: String,
      default: "2023-01",
    },
    dataMaxima: {
      type: String,
      default: () => dayjs().format("YYYY-MM"),
    },
  },

  data() {
    return {
      dataInicio: null,
      dataFim: null,
      menuDataInicio: false,
      menuDataFim: false,
      rangeSlider: [0, 0],
      mesesDisponiveis: [],
      isUpdatingFromSlider: false,
    };
  },

  computed: {
    dataInicioFormatada() {
      return this.dataInicio ? dayjs(this.dataInicio).format("MM/YYYY") : "";
    },
    dataFimFormatada() {
      return this.dataFim ? dayjs(this.dataFim).format("MM/YYYY") : "";
    },
  },

  watch: {
    dataMinima() {
      this.inicializarMesesDisponiveis();
      this.atualizarSliderDaData();
    },
    dataMaxima() {
      this.inicializarMesesDisponiveis();
      this.atualizarSliderDaData();
    },
    value: {
      handler(newVal) {
        if (newVal && newVal.dataInicio && newVal.dataFim) {
          const novaDataInicio = dayjs(newVal.dataInicio).format("YYYY-MM");
          const novaDataFim = dayjs(newVal.dataFim).format("YYYY-MM");

          if (
            this.dataInicio !== novaDataInicio ||
            this.dataFim !== novaDataFim
          ) {
            this.dataInicio = novaDataInicio;
            this.dataFim = novaDataFim;
            this.atualizarSliderDaData();
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },

  mounted() {
    this.inicializarMesesDisponiveis();
    this.inicializarDatas();
  },

  methods: {
    inicializarMesesDisponiveis() {
      const inicio = dayjs(this.dataMinima).startOf("month");
      const fim = dayjs(this.dataMaxima).startOf("month");
      const meses = [];

      let atual = inicio;
      while (atual.isBefore(fim) || atual.isSame(fim, "month")) {
        meses.push(atual.format("YYYY-MM"));
        atual = atual.add(1, "month");
      }

      this.mesesDisponiveis = meses;
      console.log(
        "Meses disponíveis:",
        meses.length,
        "de",
        inicio.format("YYYY-MM"),
        "até",
        fim.format("YYYY-MM"),
      );
    },

    inicializarDatas() {
      if (!this.value || !this.value.dataInicio || !this.value.dataFim) {
        const padrao = periodoPadrao();
        this.dataInicio = padrao.dataInicio;
        this.dataFim = padrao.dataFim;
      } else {
        this.dataInicio = dayjs(this.value.dataInicio).format("YYYY-MM");
        this.dataFim = dayjs(this.value.dataFim).format("YYYY-MM");
      }

      this.atualizarSliderDaData();
    },

    onDataInicioChange(novaData) {
      this.menuDataInicio = false;
      this.dataInicio = dayjs(novaData).format("YYYY-MM");
      this.atualizarSliderDaData();
      this.emitirMudanca();
    },

    onDataFimChange(novaData) {
      this.menuDataFim = false;
      this.dataFim = dayjs(novaData).format("YYYY-MM");
      this.atualizarSliderDaData();
      this.emitirMudanca();
    },

    atualizarSliderDaData() {
      if (
        !this.dataInicio ||
        !this.dataFim ||
        this.mesesDisponiveis.length === 0
      ) {
        return;
      }

      const indexInicio = this.mesesDisponiveis.indexOf(this.dataInicio);
      const indexFim = this.mesesDisponiveis.indexOf(this.dataFim);

      if (indexInicio !== -1 && indexFim !== -1) {
        this.rangeSlider = [indexInicio, indexFim];
      } else {
        console.warn("Datas fora do range disponível:", {
          dataInicio: this.dataInicio,
          dataFim: this.dataFim,
          indexInicio,
          indexFim,
          mesesDisponiveis: this.mesesDisponiveis.length,
        });
      }
    },

    atualizarDatasDoSlider() {
      if (this.isUpdatingFromSlider) return;

      this.isUpdatingFromSlider = true;

      const [indexInicio, indexFim] = this.rangeSlider;

      if (this.mesesDisponiveis[indexInicio]) {
        this.dataInicio = this.mesesDisponiveis[indexInicio];
      }

      if (this.mesesDisponiveis[indexFim]) {
        this.dataFim = this.mesesDisponiveis[indexFim];
      }

      this.emitirMudanca();

      this.$nextTick(() => {
        this.isUpdatingFromSlider = false;
      });
    },

    formatarMesAno(data) {
      return data ? dayjs(data).format("MM/YYYY") : "";
    },

    emitirMudanca() {
      if (!this.dataInicio || !this.dataFim) return;

      this.$emit("input", {
        dataInicio: this.dataInicio,
        dataFim: this.dataFim,
      });
    },
  },
};
</script>

<style scoped>
.slider-date-label {
  font-size: 12px;
  color: #666;
  min-width: 60px;
  text-align: center;
}

.v-input--range-slider {
  margin-top: 0;
}
</style>
